import styled from 'styled-components';
import { SectionSplitWithImageProps } from './query';
import Button_v2 from '@/components/molecules/Button/index';
import MarkdownParser from '@/components/molecules/MarkdownParser';
import Title_v2 from '@/components/molecules/Title/index';
import { MobileHeroImageContainer } from '@/components/styled';
import SplitWithImage from '@/components/wrappers/SplitWithImage';
import devices from '@/utilities/devices';
import { renderUnderline } from '@/utilities/functions';

const MarkdownContainer = styled.div`
	padding: 1rem 0 .5rem;
`;

const ButtonsContainer = styled.div`
	display: flex;
	gap: .5rem;

	@media only screen and (${devices.mobile}) and (${devices.iPhone}) {
		flex-direction: column;
		> div {
			padding: 0 0 .5rem 0;
			> a {
				margin: 0;
			}
		}
	}
`;

const SectionSplitWithImage = ({ sectionSplitWithImageData }: { sectionSplitWithImageData: SectionSplitWithImageProps }) => {

	return (
		<SplitWithImage
			backgroundColor={sectionSplitWithImageData.backgroundColor.color}
			backgroundUrl={sectionSplitWithImageData.desktopImage.data.attributes.url}
			divsSize={
				(sectionSplitWithImageData.leftSideSize && sectionSplitWithImageData.rightSideSize) ? (
					[sectionSplitWithImageData.leftSideSize, sectionSplitWithImageData.rightSideSize]
				) : null
			}
		>
			<Title_v2
				align={sectionSplitWithImageData.title.alignedAt}
				white={sectionSplitWithImageData.backgroundColor.color === 'prune'}
				underlineColor={sectionSplitWithImageData.title.underlineColor} padding='4rem 0 0 0'
			>
				{renderUnderline(sectionSplitWithImageData.title.titlePieces)}
			</Title_v2>
			<MobileHeroImageContainer
				backgroundImage={sectionSplitWithImageData?.mobileImage.data
					? sectionSplitWithImageData.mobileImage.data.attributes.url
					: sectionSplitWithImageData.desktopImage.data.attributes.url
				}
			/>
			<MarkdownContainer>
				<MarkdownParser padding={{ top: '1rem', bottom: '2.5rem' }}>
					{sectionSplitWithImageData.description}
				</MarkdownParser>
			</MarkdownContainer>
			<ButtonsContainer>
				{
					sectionSplitWithImageData.buttons && (
						sectionSplitWithImageData.buttons.map(
							(button, index) => (
								<Button_v2
									gtm_id={button.trackerId}
									href={button.url}
									key={index}
									openOnNewTab={button.newTab}
									text={button.text}
									version={button.variant}
								/>
							),
						)
					)
				}
			</ButtonsContainer>
		</SplitWithImage>
	);
};

export default SectionSplitWithImage;
